import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UiState {
  // Desktop-only sidebar collapse state (265 → 68 px). On mobile the
  // sidebar is an off-canvas drawer toggled by `mobileSidebarOpen`.
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;

  // Mobile-only drawer state. Reset on route change (not persisted) so
  // navigation always lands with the drawer closed.
  mobileSidebarOpen: boolean;
  setMobileSidebarOpen: (open: boolean) => void;
  toggleMobileSidebar: () => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),

      mobileSidebarOpen: false,
      setMobileSidebarOpen: (open) => set({ mobileSidebarOpen: open }),
      toggleMobileSidebar: () => set((s) => ({ mobileSidebarOpen: !s.mobileSidebarOpen })),
    }),
    {
      name: 'signcare.ui',
      // Persist only the desktop preference. Mobile drawer state is
      // session-local; persisting it would re-open the drawer after a
      // hard refresh, which surprises users.
      partialize: (state) => ({ sidebarCollapsed: state.sidebarCollapsed }),
    },
  ),
);
